/* gtag.js — Thin wrapper around Google Analytics 4 (gtag).
   The base GA4 script lives in /public/index.html (G-1L80SBFN8D). This helper
   just fires events and silently no-ops if gtag never loaded (e.g. blocked
   by adblocker or running in jsdom during tests). */

const safeGtag = (...args) => {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag(...args);
    }
  } catch {
    /* swallow — analytics must never crash the app */
  }
};

export const trackPageView = (path) =>
  safeGtag("event", "page_view", { page_path: path || (typeof window !== "undefined" ? window.location.pathname : "") });

export const trackEvent = (name, params = {}) =>
  safeGtag("event", name, params);

export const trackLead = (params = {}) =>
  safeGtag("event", "generate_lead", { currency: "EUR", ...params });
